import { TComponentNames, TComponentMessageMap } from '@monorepo/types';

// Define message types for each component

export type TConnectionStatus = 'DISCONNECTED' | 'CONNECTED' | 'ERROR';

export type TTvDashboardState = {
  messages: {
    [K in TComponentNames]: {
      [channelId: string]: TComponentMessageMap[K] | undefined;
    };
  };
  channelToComponentMap: {
    [channelId: string]: TComponentNames;
  };
  connectionStatus: TConnectionStatus;
};

export const TTvDashboardActionType = {
  ConnectWebSocket: 'CONNECT_WEBSOCKET' as const,
  DisconnectWebSocket: 'DISCONNECT_WEBSOCKET' as const,
  ConnectionStatus: 'CONNECTION_STATUS' as const,
  MapChannelToComponent: 'MAP_CHANNEL_TO_COMPONENT' as const,
  UpdateData: 'UPDATE_DATA' as const,
  StartListeningMessages: 'START_LISTENING_MESSAGES' as const,
  SendDataToWebsocket: 'SEND_DATA_TO_WEBSOCKET' as const,
};
